var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from "react";
import { useHistory } from "react-router-dom";
import { Pane, Button, Row, Col, PaneFooter } from "@folio/stripes/components";
import { useOkapiKy } from "@folio/stripes/core";
import { useForm, Controller, useWatch } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useIntl } from "react-intl";
import { RecekTextField } from "../../components/inputs";
import { useCreateOrganization, useCheckSimilarOrganizations, } from "../../api/organizationService";
import styles from "./OrganizationCreate.module.css";
import { organizationSchema } from "../../utils/validationUtils";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { readErrorType, resolveOrganizationSaveError, } from "../../utils/organizationUtils";
import { useScrollToError } from "../../hooks/useScrollToError";
function OrganizationCreate() {
    var _this = this;
    var history = useHistory();
    var ky = useOkapiKy();
    var intl = useIntl();
    var formatMessage = intl.formatMessage;
    var _a = React.useState(null), error = _a[0], setError = _a[1];
    var _b = React.useState(null), warning = _b[0], setWarning = _b[1];
    var _c = useForm({
        resolver: zodResolver(organizationSchema(intl)),
        defaultValues: { name: "", companyNumber: "" },
        mode: "onBlur",
    }), control = _c.control, handleSubmit = _c.handleSubmit, setFieldError = _c.setError, errors = _c.formState.errors;
    var _d = useCreateOrganization(), mutate = _d.mutate, isSaving = _d.isLoading;
    var checkSimilar = useCheckSimilarOrganizations().mutateAsync;
    useScrollToError(errors);
    var watchedName = useWatch({ control: control, name: "name" });
    React.useEffect(function () {
        if (warning && watchedName !== warning.name) {
            setWarning(null);
        }
    }, [watchedName, warning]);
    var getErrorMessage = function (error) { return __awaiter(_this, void 0, void 0, function () {
        var saveError, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = resolveOrganizationSaveError;
                    return [4 /*yield*/, readErrorType(error === null || error === void 0 ? void 0 : error.response)];
                case 1:
                    saveError = _a.apply(void 0, [_c.sent()]);
                    if ((saveError === null || saveError === void 0 ? void 0 : saveError.field) === "companyNumber") {
                        setError(null);
                        setFieldError("companyNumber", {
                            type: "server",
                            message: formatMessage({ id: saveError.messageId }),
                        });
                        return [2 /*return*/];
                    }
                    setError(formatMessage({
                        id: (_b = saveError === null || saveError === void 0 ? void 0 : saveError.messageId) !== null && _b !== void 0 ? _b : "ui-br-users.organizationCreate.error.default",
                    }));
                    return [2 /*return*/];
            }
        });
    }); };
    var performCreate = function (_a) {
        var name = _a.name, companyNumber = _a.companyNumber;
        mutate({ ky: ky, name: name, companyNumber: companyNumber }, {
            onSuccess: function () { return history.goBack(); },
            onError: getErrorMessage,
        });
    };
    var onSubmit = function (formData) { return __awaiter(_this, void 0, void 0, function () {
        var name, result, e_1, exactMatches, similarMatches;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    name = formData.name;
                    if ((warning === null || warning === void 0 ? void 0 : warning.name) === name) {
                        if (warning.allowResubmit) {
                            setWarning(null);
                            performCreate(formData);
                        }
                        // exact match: ignore — user must change the name
                        return [2 /*return*/];
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, checkSimilar({ ky: ky, name: name })];
                case 2:
                    result = _c.sent();
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _c.sent();
                    // advisory check failed — the backend hard-block remains as the safety net
                    console.error("Similar organizations check failed:", e_1);
                    performCreate(formData);
                    return [2 /*return*/];
                case 4:
                    exactMatches = (_a = result.exactMatches) !== null && _a !== void 0 ? _a : [];
                    similarMatches = (_b = result.similarMatches) !== null && _b !== void 0 ? _b : [];
                    if (exactMatches.length > 0) {
                        setError(null);
                        setWarning({
                            name: name,
                            matches: exactMatches,
                            allowResubmit: false,
                        });
                        return [2 /*return*/];
                    }
                    if (similarMatches.length > 0) {
                        setError(null);
                        setWarning({
                            name: name,
                            matches: similarMatches,
                            allowResubmit: true,
                        });
                        return [2 /*return*/];
                    }
                    performCreate(formData);
                    return [2 /*return*/];
            }
        });
    }); };
    var saveLabel = (warning === null || warning === void 0 ? void 0 : warning.allowResubmit)
        ? formatMessage({
            id: "ui-br-users.organizationCreate.button.saveAnyway",
        })
        : formatMessage({ id: "ui-br-users.organizationCreate.button.save" });
    var warningHeadlineId = (warning === null || warning === void 0 ? void 0 : warning.allowResubmit)
        ? "ui-br-users.organizationCreate.duplicateSimilar.message"
        : "ui-br-users.organizationCreate.duplicateExact.message";
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: "Vytvo\u0159it organizaci", footer: React.createElement(PaneFooter, { renderStart: React.createElement(Button, { type: "submit", buttonStyle: "primary", marginBottom0: true, disabled: isSaving || (warning !== null && !warning.allowResubmit), onClick: handleSubmit(onSubmit) }, saveLabel), renderEnd: React.createElement(Button, { buttonStyle: "default", onClick: function () { return history.goBack(); }, marginBottom0: true }, "Zru\u0161it") }) },
            React.createElement("form", { onSubmit: handleSubmit(onSubmit) },
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(Controller, { name: "name", control: control, render: function (_a) {
                                var _b, _c;
                                var field = _a.field;
                                return (React.createElement(RecekTextField, __assign({ labelId: "ui-br-users.users.organization.field.label.name" }, field, { required: true, error: (_c = (_b = errors.name) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : error })));
                            } }),
                        warning && (React.createElement("div", { role: "alert", className: styles.warning },
                            React.createElement("div", null, formatMessage({ id: warningHeadlineId })),
                            React.createElement("ul", { className: styles.warningList }, warning.matches.map(function (m) { return (React.createElement("li", { key: m.id }, m.name)); })))))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(Controller, { name: "companyNumber", control: control, render: function (_a) {
                                var _b;
                                var field = _a.field;
                                return (React.createElement(RecekTextField, __assign({ labelId: "ui-br-users.organization.field.label.companyNumber" }, field, { error: (_b = errors.companyNumber) === null || _b === void 0 ? void 0 : _b.message })));
                            } })))))));
}
export default OrganizationCreate;
